import { generateApiPath } from '@scouts/helpers'

import { UserProfileDTO } from '@/models'

import { apiSlice } from '../api-slice'
import { ENDPOINTS } from '../endpoints'

export interface RequestPhoneCallParams {
    callReason?: string
    phoneNumber: string
}

const extendedApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        requestPhoneCall: builder.mutation<void, RequestPhoneCallParams & { userId?: UserProfileDTO['id'] }>({
            query: ({ userId, ...payload }) => ({
                method: 'POST',
                url: generateApiPath(ENDPOINTS.USER.POST.REQUEST_PHONE_CALL, { userId }),
                data: payload,
            }),
        }),
        deleteAccount: builder.mutation<void, { userId: UserProfileDTO['id'] }>({
            query: ({ userId }) => ({
                method: 'DELETE',
                url: generateApiPath(ENDPOINTS.USER.DELETE.ACCOUNT, { userId }),
            }),
            // TODO: Hide error messages with { hideAlert: true }
            // transformErrorResponse: (response) => {},
        }),
    }),
})

export const { useRequestPhoneCallMutation, useDeleteAccountMutation } = extendedApi
